import { EditorState } from "draft-js";
import { aiAuditEvents } from "~/AIEvents/aiAuditEvents";
import { useTrackEvent } from "~/common/audit";
import { PostMessageViewModel } from "~/messageBoard";
import { useReduxAction } from "~/sharedComponents/hooks/useReduxAction";
import { setAiCompletion } from "../state/reducers";
import { appendSuggestion, replaceSuggestion, cleanupSuggestion } from "../utils";

export const useApplySuggestions = (vm: PostMessageViewModel) => {
    const track = useTrackEvent();
    const setCompletion = useReduxAction(setAiCompletion);
    const focusEditor = () => vm.isFocused(true);

    const applySuggestion = (modifier: (sate: EditorState) => EditorState, action: string) => () => {
        track({ eventName: aiAuditEvents.aiMessageApplied, action });
        const result = modifier(vm.editorState());
        vm.editorState(result);
        setCompletion(null);
        focusEditor();
    };

    const append = applySuggestion(appendSuggestion, "append");
    const replace = applySuggestion(replaceSuggestion, "replace");
    const discard = applySuggestion(cleanupSuggestion, "discard");

    return { append, replace, discard };
};
